import React, { FC } from 'react';
import { RootState, useSelector } from 'src/store';
import EditTracking from '../editor/EditTracking';

export const initTrackingValues = {
  tracking: {
    multi_image: ['shop now - image1', 'shop now - image2'],
    multi_button: ['shop now - button1', 'shop now - button2'],
    button: ['close - button', 'close - button']
  }
};

const FullDualImage: FC = () => {
  const currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  const text = useSelector((state: RootState) => state.editText.text);
  const tracking = useSelector((state: RootState) => state.trackings.tracking);

  const style = `
    a {
      color: #000000;
      text-decoration: none;
      cursor: pointer;
    }

    .root_tracking {
      width: 100%;
      height: 100%;

      overflow: hidden;
      position: relative;

      .center_wrapper {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;

        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .contents_wrapper {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
      }
      .center_wrapper .title {
        height: 3.5rem;
        display: flex;
        align-items: center;
      }
      .center_wrapper .sub_title {
        width: 100%;
        height: 2.5rem;

        display: flex;
        align-items: center;
      }

      .contents_wrapper .image_box {
        width: 100%;
        height: 160px;
        position: relative;
      }
      .contents_wrapper .image {
        width: 100%;
        min-height: 160px;
      }
      .contents_wrapper .multi_title {
        width: 100%;
        height: 2rem;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        display: flex;
        align-items: center;
      }
      .contents_wrapper .multi_sub_title {
        height: 1.5rem;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        display: flex;
        align-items: center;
      }

      .contents_wrapper .multi_button {
        width: 100%;
        min-height: 22.67px;
        position: absolute;
        right: 0;
        bottom: 1rem;
      }

      .bottom_wrapper {
        width: 100%;
        height: 3rem;
        margin-top: 2rem;
      }

      .tracking_center {
        display: flex;
        align-items: center;
        justify-content: end;
      }
    }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_tracking">
        <div className="center_wrapper">
          <div className="title" />
          <div className="sub_title" />
          {text?.multi_title?.map((data: any, idx: number) => (
            // currentIndex === idx && (
            <div key={idx} className="contents_wrapper">
              <div className="image_box">
                <div className="image tracking_center">
                  {currentIndex === idx && (
                    <EditTracking
                      value={tracking?.multi_image?.[idx]}
                      type="multi_image"
                    />
                  )}
                </div>
                <div className="multi_button tracking_center">
                  {currentIndex === idx && (
                    <EditTracking
                      value={tracking?.multi_button?.[idx]}
                      type="multi_button"
                    />
                  )}
                </div>
              </div>
              <div>
                <div className="multi_title" />
                <div className="multi_sub_title" />
              </div>
            </div>
            // )
          ))}
          <div className="bottom_wrapper tracking_center">
            <EditTracking value={tracking?.button?.[0]} type="button" />
          </div>
        </div>
      </div>
    </>
  );
};

export default FullDualImage;
